<template>
  <v-dialog
    v-on="$listeners"
    v-bind="$attrs"
    scrollable
    max-width="800px"
    transition="dialog-transition"
    :fullscreen="isPrinting"
  >
    <v-card color="red white--text">
      <v-card-title>{{ title }}</v-card-title>

      <v-card-text>
        <m-datatable
          :headers="errorHeaders"
          :items="errors"
          :filters.sync="errorFilters"
          :isDialog="true"
          :show-applied-filters="false"
          :show-select="false"
        >
        </m-datatable>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      default: "لطفا خطا های زیر را برطرف کنید",
    },
    errors: {
      required: true,
    },
    errorFilters: {},
    errorHeaders: {
      default: () => {
        return [
          {
            text: "متن خطا",
            value: "text",
            dontTruncate: true
          },
        ];
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style></style>
